import { Component } from '@angular/core';

@Component({
  selector: 'ni-dialog-body',
  template: '<ng-content></ng-content>'
})
export class DialogBodyComponent {}
